import { useState } from "react";
import { DynamicIcon, IconName } from "lucide-react/dynamic";
import { Popover, PopoverContent, PopoverTrigger } from "~/components/ui/popover";
import { cn } from "~/lib/utils";
import { DEFAULT_ICON, ICON_OPTIONS } from "./constants";

interface IconPickerProps {
  value: string | null;
  onChange: (icon: IconName) => void;
  disabled?: boolean;
}

export const IconPicker = ({ value, onChange, disabled }: IconPickerProps) => {
  const [open, setOpen] = useState(false);
  const selected = (value ?? DEFAULT_ICON) as IconName;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild disabled={disabled}>
        <button
          type="button"
          aria-label="Choose icon"
          className="flex size-14 cursor-pointer items-center justify-center rounded-lg bg-primary/10 transition-colors hover:bg-primary/15 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <DynamicIcon name={selected} className="size-6 text-primary" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="z-[1300] w-72 p-3">
        <div className="grid grid-cols-6 gap-2">
          {ICON_OPTIONS.map((name) => (
            <button
              key={name}
              type="button"
              aria-label={name}
              aria-pressed={name === selected}
              onClick={() => {
                onChange(name);
                setOpen(false);
              }}
              className={cn(
                "flex aspect-square cursor-pointer items-center justify-center rounded-md border transition-colors",
                name === selected
                  ? "border-primary bg-primary/10"
                  : "border-transparent hover:bg-muted"
              )}
            >
              <DynamicIcon name={name} className="size-4" />
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
